export default __webpack_public_path__ + "assets/images/34ad7880e06ec05c1dbb0f6461799ef8.png";